import React, { ReactElement } from 'react'
import ProofOfResidencyType from '../../../components/verification-steps/steps/proof-of-residency/ProofOfResidencyType'
import verificationStore from '../../../stores/verificaton.store'

const UserProofOfResidencyType: React.FC = (): ReactElement => {
  return <ProofOfResidencyType verificationStore={verificationStore} />
}

export default UserProofOfResidencyType
